// extracted by mini-css-extract-plugin
module.exports = {"modal":"WalletConnected_modal__FIxx9","icon":"WalletConnected_icon__qgTXQ","circle":"WalletConnected_circle__3u0pB","title":"WalletConnected_title__DgvWs"};